<div
  [bfx-input]="bfxInput"
  *ngIf="fieldsGroup"
  [ngClass]="inputDirective.labelClasses"
  class="interface-control__custom-input-autocomplete__label"
>
  {{ data.label }}
</div>
<bfx-autoComplete
  #inputField
  [(ngModel)]="data.item"
  [label]="fieldsGroup ? null: data.label"
  [suggestions]="data.filteredItems"
  (completeMethod)="autocompleteSearch($event)"
  [disabled]="data.disabled  || locked"
  (onFocus)="onFocus($event)"
  (onBlur)="onBlur($event)"
  (onSelect)="onSelect($event)"
  (ngModelChange)="onLowLevelModelChanged($event, data)"
  [field]="data.autocompleteField"
  [selectedField]="'label'"
  [autoHighlight]="true"
  [skipSorting]="true"
  delay="4"
  [nativeDesktopDropdown]="modeString"
  [target]="modeString"
  [state]="data.state"
  [dropdown]="true"
  [minLength]="1"
  [size]="'sm'"
  [tooltipOnItem]="true"
  [appendTo]="'body'"
  class="interface-control__custom-input-autocomplete__autocomplete"
>
  <!-- <ng-template let-dataItem pTemplate="item">
    <div
      class="ui-helper-clearfix"
      [ngClass]="{
        'bfx-autocomplete_dropdown-list_field': !dataItem.lastFavorite,
        'bfx-autocomplete_dropdown-list_last-favorite': dataItem.lastFavorite
      }"
    >
      <div>{{dataItem.smartLabel != null ? dataItem.smartLabel : dataItem.label}}</div>
    </div>
  </ng-template> -->
</bfx-autoComplete>
